import React, { useMemo } from 'react';

import { TableMapDraft } from '../context';
import { computeRoom, tableFootprintPx } from '../mapGeometry';
import MapEditorCanvas from './MapEditorCanvas';
import TableFigure from './TableFigure';

interface TableMapPreviewProps {
    draft: Pick<
        TableMapDraft,
        'size' | 'area' | 'entrances' | 'features' | 'tables' | 'tableDefaults'
    >;
}

/** Read-only map that fills its parent, which must have a definite height. */
export default function TableMapPreview({ draft }: TableMapPreviewProps) {
    const room = useMemo(() => computeRoom(draft.size), [draft.size.width, draft.size.height]);

    return (
        <MapEditorCanvas
            gridEnabled={false}
            zoom={1}
            size={draft.size}
            area={draft.area}
            openings={draft.entrances}
            features={draft.features}
        >
            {draft.tables.map((table) => {
                const cx = room.x + table.x * room.width;
                const cy = room.y + table.y * room.height;
                const { width, height } = tableFootprintPx(
                    table.shape,
                    table.width,
                    table.height,
                    draft.tableDefaults,
                    room
                );
                return (
                    <g key={table.id} transform={`translate(${cx}, ${cy})`}>
                        <TableFigure
                            width={width}
                            height={height}
                            seats={table.seats}
                            shape={table.shape}
                            label={table.label}
                            isActive={table.isActive}
                            rotation={table.rotation}
                        />
                    </g>
                );
            })}
        </MapEditorCanvas>
    );
}
